import axios from '@/configs/Axios'
import Vue from 'vue'

const state = () => ({
    comments: {},
    commentsCount: {}
})

const mutations = {
    SET_COMMENTS(state, payload) {
        Vue.set(state.comments, payload.key, payload.value)
        Vue.set(state.commentsCount, payload.key, payload.count)
    },
    PUSH_COMMENTS(state, payload) {
        if(payload.previewMode && state.comments[payload.key].length === payload.previewSize) {
            state.comments[payload.key] = []
        }
        state.comments[payload.key] = state.comments[payload.key].concat(payload.value)
    },
    COMMENT_ADD(state, payload) {
        if(payload.type === 'main_list') {
            state.comments[payload.key].push(payload.value)
            state.commentsCount[payload.key] = state.commentsCount[payload.key]+1
        } else {
            if(payload.parent && payload.parent.child) {
                payload.parent.child.push(payload.value)
            } else {
                payload.parent.child = [payload.value]
            }
        }
    },
    CHANGE_ELEM(state, payload) {
        payload.elem.child = payload.value
    },
    DELETE_COMMENT(state, payload) {
        if(payload.relatedItem) {
            if(payload.relatedItem.child && payload.relatedItem.child.length) {
                const index = payload.relatedItem.child.findIndex(item => item.uid === payload.item.uid)
                payload.relatedItem.child.splice(index, 1)
            }
        } else {
            const index = state.comments[payload.key].findIndex(item => item.uid === payload.item.uid)
            state.comments[payload.key].splice(index, 1)
            state.commentsCount[payload.key] = state.commentsCount[payload.key]-1
        }
    }
}

const actions = {
    getComment({commit}, {uid, page_size = 10, page = 1, type, previewMode, previewSize}) {
        return new Promise((resolve, reject) => {
            axios.get('/common/comments/', {
                params: {
                    related_to: uid,
                    page_size,
                    page
                }
            })
                .then(({data}) => {
                    if(type === 'set')
                        commit('SET_COMMENTS', {key: uid, value: data.results, count: data.count})
                    else
                        commit('PUSH_COMMENTS', {key: uid, value: data.results, previewMode, count: data.count, previewSize})

                    resolve(data)
                })
                .catch((error) => { reject(error) })
        })
    },
    getChildComment({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios.get('/common/comments/', {
                params: {
                    related_to: payload.uid
                }
            })
                .then(({data}) => {
                    commit('CHANGE_ELEM', {elem: payload, value: data.results})
                    resolve(data)
                })
                .catch((error) => { reject(error) })
        })
    },
    addComment({commit}, payload) {
        return new Promise((resolve, reject) => {
            const queryData = {
                comment: payload.comment,
                text: payload.text
            }
            axios.post('/common/comments/', queryData)
                .then(({data}) => {
                    commit('COMMENT_ADD', {key: payload.comment, type: payload.type, value: data, parent: payload.parent})
                    resolve(data)
                })
                .catch((error) => { reject(error) })
        })
    },
    deleteComment({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios.delete(`/common/comments/${ payload.item.uid }/`)
                .then(() => {
                    commit('DELETE_COMMENT', payload)
                    if(payload.relatedItem)
                        resolve({update: true})
                    else
                        resolve({update: false})
                })
                .catch((error) => { reject(error) })
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
